// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.ui.label.in_process {\n  background-color: #3883A8;\n  color: white;\n}\ndiv.ui.label.photos_ready {\n  background-color: #2DB84B;\n  color: white;\n}\ndiv.ui.label.published {\n  background-color: #2DB84B;\n  color: white;\n}\ndiv.ui.label.awaiting_payment {\n  background-color: #FF695E;\n  color: white;\n}\ndiv.ui.label.inactive {\n  background-color: #E0E1E2;\n  color: #4D4D4D;\n}\n", ""]);
// Exports
module.exports = exports;
